import {
    CardBreakpointRatios,
    ContentDataDefinitionLoader,
    createCollectionAvailableEvent,
    createRegisterableComponentWithData,
    FixedRatio,
    Product,
} from '@news-mono/web-common'
import React from 'react'
import { MediaMode } from '../../cards/CardMedia/CardMedia'
import { TeaserMode } from '../../cards/CardText/CardTeaser'
import { KickerMode } from '../../cards/Kicker/Kicker'
import { LandscapeLayout } from '../../cards/Landscape/Landscape.layouts'
import {
    LoadMore,
    LoadMoreRouteProps,
} from '../../collections-new-loadmore/LoadMore/LoadMore'
import {
    calculateExpectedCardCountFromContentData,
    CollectionRouteProps,
} from '../../collections/collections-props.routing'
import { Juliet } from '../../collections/Juliet/Juliet'
import { TimestampType } from '../../content/CardTimestamp/CardTimestamp'
import { ContainerWidthRatios } from '../../content/Picture/responsive'

export interface JulietRouteProps
    extends CollectionRouteProps,
        LoadMoreRouteProps {
    hideByline?: boolean
    showLargeCard?: boolean
    timestamp?: TimestampType
    cardType: LandscapeLayout | 'LandscapeWide'
    fixedRatios?: FixedRatio | FixedRatio[] | CardBreakpointRatios
    removeHorizontalGutters?: boolean
    disableImageLazyLoad?: boolean
    stickyOffset?: number | undefined
    mediaMode?: MediaMode
    teaserMode?: TeaserMode
    kickerMode?: KickerMode
    contentIsTangential?: boolean
    containerWidthRatios?: ContainerWidthRatios
}

export const JulietRegistration = createRegisterableComponentWithData(
    'juliet',
    ContentDataDefinitionLoader,
    (props: JulietRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                onLoadMore={(loadMoreData) => {
                    services.onEvent(
                        createCollectionAvailableEvent(
                            loadMoreData.result.publications,
                            'juliet',
                            Product.TheWest,
                            services.onEvent,
                        ),
                    )
                }}
                render={(loadMoreData) => {
                    return (
                        <Juliet
                            items={
                                loadMoreData.loaded
                                    ? {
                                          loaded: true,
                                          result: loadMoreData.result
                                              .publications,
                                      }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs,
                            )}
                            sectionHeader={props.sectionHeader}
                            kickerMode={props.kickerMode}
                            teaserMode={props.teaserMode}
                            hideByline={props.hideByline}
                            fixedRatios={props.fixedRatios}
                            cardType={props.cardType}
                            showLargeCard={props.showLargeCard}
                            timestamp={props.timestamp}
                            removeHorizontalGutters={
                                props.removeHorizontalGutters
                            }
                            verticalSpacing={
                                props.loadMoreEnabled
                                    ? props.verticalSpacing
                                    : 'md'
                            }
                            disableImageLazyLoad={props.disableImageLazyLoad}
                            onEvent={services.onEvent}
                            mediaMode={props.mediaMode}
                            contentIsTangential={props.contentIsTangential}
                            containerWidthRatios={props.containerWidthRatios}
                        />
                    )
                }}
            />
        )
    },
)
